import { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import axios from "axios";
import TulioLanding from "./components/TulioLanding";
import ServicesPage from "./components/ServicesPage";
import ServiceDetailPage from "./components/ServiceDetailPage";
import CaseStudiesPage from "./components/CaseStudiesPage";
import CaseStudyDetailPage from "./components/CaseStudyDetailPage";
import IndustriesPage from "./components/IndustriesPage";
import IndustryDetailPage from "./components/IndustryDetailPage";
import GovernmentPage from "./components/GovernmentPage";
import EnterprisePage from "./components/EnterprisePage";
import StartupsPage from "./components/StartupsPage";
import ContactSection from "./components/ContactSection";
import ScrollToTop from "./ScrollToTop";


const Home = () => {

  return <TulioLanding />;
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
          <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services" element={<ServicesPage />} />
          <Route path="/services/:serviceId" element={<ServiceDetailPage />} />
          <Route path="/case-studies" element={<CaseStudiesPage />} />
          <Route path="/case-studies/:caseId" element={<CaseStudyDetailPage />} />
          <Route path="/industries" element={<IndustriesPage />} />
          <Route path="/industries/:industryId" element={<IndustryDetailPage />} />
          <Route path="/government" element={<GovernmentPage />} />
          <Route path="/enterprise" element={<EnterprisePage />} />
          <Route path="/startups" element={<StartupsPage />} />
          <Route path="/ContactSection" element={<ContactSection />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;